module.exports = __webpack_public_path__ + "static/media/strap_section_terminal.79f6e88a.webp";